import { Check, ChevronDown, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { useApp } from "../context/AppContext";

const TYPE = { tournee: "Tournée à domicile", missions: "Missions", mixte: "Tournée et missions", individuel: "Planning individuel" };
const ROLE = { owner: "Responsable", co: "Co-responsable", nurse: "Infirmière" };

export function StructureSwitcher() {
  const { structures, current, setSid, user } = useApp();
  const nav = useNavigate();
  if (!current) return <span className="font-bold text-teal-900">AVELIS Planning</span>;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="structure-switcher-button" className="flex min-w-0 max-w-[70vw] items-center gap-1.5 rounded-xl px-2 py-1.5 text-left hover:bg-slate-100">
          <div className="min-w-0">
            <div className="truncate text-sm font-bold text-slate-900">{current.name}</div>
            <div className="text-[10px] font-semibold uppercase tracking-wider text-slate-500" data-testid="current-role-label">
              {current.support ? "Support AVELIS · lecture seule" : user?.is_superadmin ? "Super admin" : ROLE[current.role]}
            </div>
          </div>
          <ChevronDown className="h-4 w-4 shrink-0 text-slate-500" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-72 rounded-xl bg-white p-1">
        {structures.map((s) => (
          <DropdownMenuItem key={s.id} data-testid={`structure-option-${s.id}`} onClick={() => { setSid(s.id); nav("/"); }} className="flex min-h-[48px] cursor-pointer items-center justify-between rounded-lg">
            <div>
              <div className="font-semibold">{s.name}</div>
              <div className="text-xs text-slate-500">{TYPE[s.type]} · {ROLE[s.role]}</div>
            </div>
            {s.id === current.id && <Check className="h-4 w-4 text-teal-600" />}
          </DropdownMenuItem>
        ))}
        {(user?.can_create_structures || user?.is_superadmin) && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem data-testid="structure-create-link" onClick={() => nav("/structure/nouvelle")} className="min-h-[44px] cursor-pointer gap-2 rounded-lg text-teal-700">
              <Plus className="h-4 w-4" /> Créer une équipe
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export const STRUCTURE_TYPES = TYPE;
